import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { TeacherResponseWithClassIds } from '../models/teacher-response-with-classIds';
import { Observable } from 'rxjs';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { HttpHeaders } from '@angular/common/http';
import { TeacherResponse } from '../models/teacher-response';
import { SCHOOL_ID_HEADER } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class TeacherService {
  apiService = inject(ApiService);

  getTeacher(teacherId: string, schoolId: string = null): Observable<TeacherResponse> {
    const getURL = `api/Teachers/${teacherId}`;
    return this.apiService.invokeLSApi<TeacherResponse>(getURL, HttpAction.Get, null, {
      additionalHeaders: schoolId ? new HttpHeaders({ [SCHOOL_ID_HEADER]: schoolId }) : null,
    });
  }

  getTeachersBySchoolAndClasses(
    schoolId: string,
    classIds: string[]
  ): Observable<TeacherResponseWithClassIds[]> {
    const url = `api/Schools/${schoolId}/ClassesTeachers`;
    return this.apiService.invokeLSApi<TeacherResponseWithClassIds[]>(
      url,
      HttpAction.PostWithBodyResponse,
      classIds,
      { additionalHeaders: new HttpHeaders({ [SCHOOL_ID_HEADER]: schoolId }) }
    );
  }
}
